import React from 'react';

import { CloseX } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';
import { Modal } from '@vimeo/iris/layout';
import { Link, Paragraph } from '@vimeo/iris/typography';
import { JoinForm, LoginForm } from '@vimeo/ui/core/form/forms';

import styles from './AuthModal.module.scss';

interface AuthModalProps {
  active: boolean;
  children: React.ReactElement;
  dismiss: VoidFunction;
  redirectUrl?: string;
  type: string;
}

const AuthModal = ({ active, children, dismiss, redirectUrl = '', type }: AuthModalProps) => {
  const onSuccess = () => {
    window.location.reload();
  };

  const LoginContent = () => (
    <div className={styles.modal_content}>
      <div className={styles.dismiss_wrapper}>
        <Modal.Header>{translate('Log in to Vimeo')}</Modal.Header>
        <CloseX onClick={dismiss} />
      </div>
      <LoginForm xsrft={window?.devsite?.xsrft} onSuccess={onSuccess} redirectUrl={redirectUrl} />
      <Paragraph size="2">
        {translate("Don't have an account?")}{' '}
        <Link variant="minimal" href={window?.devsite?.vimeo_url + '/join'}>
          {translate('Join')}
        </Link>
      </Paragraph>
    </div>
  );

  const JoinContent = () => (
    <div className={styles.modal_content}>
      <div className={styles.dismiss_wrapper}>
        <Modal.Header>{translate('Join Vimeo')}</Modal.Header>
        <CloseX onClick={dismiss} />
      </div>
      <JoinForm xsrft={window?.devsite?.xsrft} onSuccess={onSuccess} redirectUrl={redirectUrl} />
      <Paragraph size="2">
        {translate('Already have an account?')}{' '}
        <Link variant="minimal" href={'log_in'}>
          {translate('Log in')}
        </Link>
      </Paragraph>
    </div>
  );

  return (
    <Modal
      onOpen={dismiss}
      className={styles.modal}
      active={active}
      content={type === 'login' ? <LoginContent /> : <JoinContent />}
    >
      {children}
    </Modal>
  );
};

export default AuthModal;
